
export const SET_LOGIN_STATUS = "setLoginStatus";

export const SET_USERINFO = "setUserInfo";

export const SET_AGENT_ID = "setAgentId";
